export default "__VITE_ASSET__DTRb$T8k__"